<app-datos-simulacion-salud [esDental]="true"></app-datos-simulacion-salud>